/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {
  // Prevent unwanted scroll on homepage caused by section-product
  document.addEventListener('DOMContentLoaded', () => {
    const isHomePage =
      window.location.pathname === '/' ||
      window.location.pathname === '/index.html';

    if (isHomePage) {
      // Force scroll to top
      window.scrollTo(0, 0);

      // Unfocus any element that might be auto-focused
      const observer = new MutationObserver(() => {
        if (
          document.activeElement &&
          document.activeElement.closest('.section-product')
        ) {
          document.activeElement.blur();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Optional: disconnect the observer after a while (e.g., 3s)
      setTimeout(() => observer.disconnect(), 3000);
    }
  });

  // Example event listeners
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });

  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  document.addEventListener('theme:scroll', (e) => {
    console.log(e);
  });
  document.addEventListener('theme:scroll:up', (e) => {
    console.log(e);
  });
  document.addEventListener('theme:scroll:down', (e) => {
    console.log(e);
  });

  document.addEventListener('theme:resize', (e) => {
    console.log(e);
  });

  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
})();
